import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown'; // Import NavDropdown
import Container from 'react-bootstrap/Container';
import risingImg from './../../utils/images/logo.png';  // Import the image
import './NavCom.css';  // Import custom CSS file for additional styling

function NavCom() {
  return (
    <Navbar expand="lg" className='navbar-custom position-absolute w-100'>
      <Container>
        <Navbar.Brand>
          <Link to="/" className='navbar-brand d-flex align-items-center'>
            <img src={risingImg} alt="Rising Sun Academy Logo" width="100" height="60" />
            <span className='mx-2 lh-1 fw-semibold'>
              {/* Educare */}
              <br></br>
            </span>
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='basic-navbar-nav' className='bg-light' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='me-auto justify-content-end w-100'>
            <Nav.Link href='/' className='nav-link-custom  text-uppercase'>Home</Nav.Link>
            <Nav.Link href='/courses' className='nav-link-custom text-uppercase'>Our courses</Nav.Link>
            <Nav.Link href='/about' className='nav-link-custom text-uppercase'>About us</Nav.Link>
            <Nav.Link href='/contact' className='nav-link-custom text-uppercase'>Get in touch</Nav.Link>

            {/* Dropdown for Study Abroad */}
            <NavDropdown title="Study Abroad" id="study-abroad-dropdown" className='nav-link-custom text-uppercase'>
              <NavDropdown.Item href='/australia'>Australia</NavDropdown.Item>
              <NavDropdown.Item href='/uk'>United Kingdom</NavDropdown.Item>
              <NavDropdown.Item href='/nz'>New Zealand</NavDropdown.Item>
              <NavDropdown.Item href='/canada'>Canada</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavCom;
